import cn from 'classnames'
import React from 'react'
import { NavLink, useRouteMatch } from 'react-router-dom'

export default function SettingsTabs() {
    const { path } = useRouteMatch()

    return (
        <div className="tabs">
            <ul>
                <li className={cn({ 'is-active': path.startsWith('/settings/user') })}>
                    <NavLink to="/settings/user">Аккаунт пользователя</NavLink>
                </li>
                <li className={cn({ 'is-active': path.startsWith('/settings/currency') })}>
                    <NavLink to="/settings/currency">Валюта</NavLink>
                </li>
                <li className={cn({ 'is-active': path.startsWith('/settings/category') })}>
                    <NavLink to="/settings/category">Категория</NavLink>
                </li>
            </ul>
        </div>
    )
}
